import React from "react";
import { Navigate, useParams } from "react-router-dom";

const RedirectToPatientDashboard = () => {
    const { id } = useParams();
    return <Navigate to={`/facilitateurs/patient/${id}/dashboard`} replace />;
};

export default RedirectToPatientDashboard;
